module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/fsevents/~/safe-buffer/browser.js
// module id = 300
// module chunks = 0